import { html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SsoElement } from './sso-base.js';

/**
 * `<sso-card>` — the centered surface used by the auth flow screens (SSO-MOCKUPS.md).
 * A simple Odoo-like panel with the card shadow, max-width clamped to `--sso-card-max`,
 * full-width with padding on small screens. Content goes in the default slot.
 */
@customElement('sso-card')
export class SsoCard extends SsoElement {
  static override styles = [
    SsoElement.styles,
    css`
      :host {
        display: block;
        width: 100%;
        max-width: var(--sso-card-max);
        margin: clamp(1.5rem, 6vh, 4rem) auto;
        background: var(--sso-color-surface);
        border: 1px solid var(--sso-color-border);
        border-radius: var(--sso-radius);
        box-shadow: var(--sso-shadow-card);
        padding: var(--sso-space-lg);
      }
      @media (max-width: 600px) {
        :host {
          margin: 0 auto;
          border-inline: none;
          border-radius: var(--sso-radius);
          box-shadow: none;
          min-height: calc(100dvh - var(--sso-appbar-height));
          padding: var(--sso-space);
        }
      }
      ::slotted(h1) {
        margin-top: 0;
      }
    `,
  ];

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sso-card': SsoCard;
  }
}
